import Campervan from "../../../images/icons/camper-van.png";
import SprinterType from "../../../images/icons/camper-van.png";
import CaboverMotorhome from "../../../images/icons/camper-van.png";
import SemiIntegratedMotorhome from "../../../images/icons/camper-van.png";
import IntegratedMotorhome from "../../../images/icons/camper-van.png";
import RoofTent from "../../../images/icons/camper-van.png";
import Other from "../../../images/icons/camper-van.png";

export const camperData = {
  camper: {
    types: [
      "Campervan",
      "Sprinter-Type",
      "Cabover Motorhome",
      "Semi-integrated Motorhome",
      "Integrated Motorhome",
      "Roof Tent",
      "Other",
    ],
    icons: {
      Campervan,
      "Sprinter-Type": SprinterType,
      "Cabover Motorhome": CaboverMotorhome,
      "Semi-integrated Motorhome": SemiIntegratedMotorhome,
      "Integrated Motorhome": IntegratedMotorhome,
      "Roof Tent": RoofTent,
      Other,
    },
  },
};
